import { useContext, useState } from "react";
import {
  Box,
  Stack,
  Collapse,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Radio,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DisabledByDefaultRoundedIcon from "@mui/icons-material/DisabledByDefaultRounded";
import { FiEdit } from "react-icons/fi";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { SelectGroupFee } from "../../../Components/Include/DynamicSelect/DynamicSelect";
import { TransitionGroup } from "react-transition-group";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";

const ItemList = ({ listItemData, setListItemData, required }) => {
  const { t } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const newEntry = {
    groupFeeId: { id: "", title: "", price: "" },
    startDate: null,
    endDate: null,
    discountType: "amount",
    discount: 0,
    qty: 1,
    price: 0,
  };

  // console.log("listItemData::", listItemData);

  const handleAdd = () => {
    setListItemData((prev) => [...prev, newEntry]);
  };

  const handleRemove = (index) => {
    setListItemData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChangeValue = (index, value, field) => {
    // console.log("index, value, field...", index, value, field);
    setListItemData((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const [selectedValue, setSelectedValue] = useState("amount");

  const handleChange = (index, val, field) => {
    handleChangeValue(index, val, field);
    setSelectedValue(val);
    handleClose();
    handleChangeValue(index, 0, "discount");
  };

  return (
    <Stack direction="column" spacing={2}>
      <Stack
        spacing={0.6}
        direction="row"
        alignItems="center"
        sx={{ borderBottom: "1px solid gray" }}
      >
        <Typography className={t("class-name-field-title")} width="25%">
          {t("thead_other_materials")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="13%">
          {t("thead_start_date")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="13%">
          {t("thead_end_date")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="10%">
          {t("thead_amount")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="5%">
          {t("thead_qty")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="10%">
          {t("thead_discount")}
        </Typography>

        <Typography
          className={t("class-name-field-title")}
          width="5%"
        ></Typography>

        <Typography className={t("class-name-field-title")} width="14%">
          {t("thead_total")}
        </Typography>

        <Box sx={{ width: "5%" }}>
          <IconButton onClick={handleAdd} title={t("add")}>
            <AddBoxIcon sx={{ color: "green" }} />
          </IconButton>
        </Box>
      </Stack>

      {/* List with TransitionGroup */}
      <TransitionGroup>
        {listItemData?.map((item, index) => {
          // console.log("item::", item);
          return (
            <Collapse key={index}>
              <Stack
                spacing={0.6}
                direction="row"
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Box width="25%">
                  <SelectGroupFee
                    buttonAdd={false}
                    error={required && !item?.groupFeeId?.id}
                    dataOptions={listItemData}
                    value={item?.groupFeeId}
                    onChange={(val) => {
                      // console.log("val::", val)
                      handleChangeValue(index, val, "groupFeeId");
                      handleChangeValue(index, val?.price, "price");
                      handleChangeValue(index, 1, "qty");
                      handleChangeValue(index, 0, "discount");
                    }}
                  />
                </Box>

                <Box width="13%">
                  <SelectDatePicker
                    value={item?.startDate}
                    onChange={(val) =>
                      handleChangeValue(index, val, "startDate")
                    }
                  />
                </Box>

                <Box width="13%">
                  <SelectDatePicker
                    value={item?.endDate}
                    onChange={(val) => handleChangeValue(index, val, "endDate")}
                  />
                </Box>

                <Box width="10%">
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={!item?.groupFeeId?.id}
                    className="text-field"
                    value={item?.price}
                    onChange={({ target }) =>
                      handleChangeValue(index, target?.value, "amount")
                    }
                    placeholder={t("thead_amount")}
                    InputProps={{
                      endAdornment: (
                        <Typography className={t("class-name-field-title")}>
                          $
                        </Typography>
                      ),
                    }}
                  />
                </Box>

                <Box width="5%">
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={!item?.groupFeeId?.id}
                    className="text-field"
                    value={item?.qty}
                    onChange={({ target }) => {
                      if (target?.value <= 0) {
                        handleChangeValue(index, 1, "qty");
                        handleChangeValue(index, 0, "discount");
                      } else {
                        handleChangeValue(index, target?.value, "qty");
                        handleChangeValue(index, 0, "discount");
                      }
                    }}
                    placeholder={t("thead_qty")}
                  />
                </Box>

                {item?.discountType === "amount" ? (
                  <Box width="10%">
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      disabled={!item?.groupFeeId?.id}
                      className="text-field"
                      value={item?.discount}
                      onChange={({ target }) => {
                        if (
                          target?.value >= 0 &&
                          target?.value <= item?.price * item?.qty
                        ) {
                          handleChangeValue(index, target?.value, "discount");
                        } else {
                          handleChangeValue(
                            index,
                            item?.price * item?.qty,
                            "discount"
                          );
                        }
                      }}
                      placeholder={t("thead_discount")}
                      inputProps={{ min: 0, max: item?.price }}
                      InputProps={{
                        endAdornment: (
                          <Typography className={t("class-name-field-title")}>
                            $
                          </Typography>
                        ),
                      }}
                    />
                  </Box>
                ) : (
                  <Box width="10%">
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      disabled={!item?.groupFeeId?.id}
                      className="text-field"
                      value={item?.discount}
                      onChange={({ target }) => {
                        if (target?.value >= 0 && target?.value <= 100) {
                          handleChangeValue(index, target?.value, "discount");
                        } else {
                          handleChangeValue(index, item?.price, "discount");
                        }
                      }}
                      placeholder={t("thead_discount")}
                      inputProps={{ min: 0, max: item?.price }}
                      InputProps={{
                        endAdornment: (
                          <Typography className={t("class-name-field-title")}>
                            %
                          </Typography>
                        ),
                      }}
                    />
                  </Box>
                )}

                <Box width="5%">
                  <Tooltip title={t("update")} placement="top">
                    <IconButton onClick={handleClick}>
                      <FiEdit />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    slotProps={{
                      list: {
                        "aria-labelledby": "basic-button",
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() =>
                        handleChange(index, "amount", "discountType")
                      }
                    >
                      <Radio
                        checked={selectedValue === "amount"}
                        value="amount"
                        name="radio-buttons"
                        slotProps={{ input: { "aria-label": "A" } }}
                        sx={{ padding: "2px !important" }}
                      />
                      {t("money")} ($)
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        handleChange(index, "percentage", "discountType")
                      }
                    >
                      <Radio
                        checked={selectedValue === "percentage"}
                        value="percentage"
                        name="radio-buttons"
                        slotProps={{ input: { "aria-label": "B" } }}
                        sx={{ padding: "2px !important" }}
                      />
                      {t("percentage")} (%)
                    </MenuItem>
                  </Menu>
                </Box>

                <Box width="14%">
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={!item?.groupFeeId?.id}
                    className="text-field"
                    value={
                      item?.discountType === "percentage" && item?.discount > 0
                        ? item?.price * item?.qty * (1 - item?.discount / 100)
                        : item?.price * item?.qty - item?.discount
                    }
                    placeholder={t("thead_total")}
                    InputProps={{
                      endAdornment: (
                        <Typography className={t("class-name-field-title")}>
                          $
                        </Typography>
                      ),
                    }}
                  />
                </Box>

                <Box sx={{ width: "5%" }}>
                  <IconButton
                    onClick={() => handleRemove(index)}
                    title={t("remove")}
                  >
                    <DisabledByDefaultRoundedIcon sx={{ color: "red" }} />
                  </IconButton>
                </Box>
              </Stack>
            </Collapse>
          );
        })}
      </TransitionGroup>
    </Stack>
  );
};

export default ItemList;
